import { render, staticRenderFns } from "./ModalWage.vue?vue&type=template&id=4a0074ac&"
import script from "./ModalWage.vue?vue&type=script&lang=js&"
export * from "./ModalWage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports